export default __webpack_public_path__ + "static/media/pic2.bb0c2c0e.jpg";